export const styles = {
  text: { typography: { xs: '14_18_500' } },
};
